/**
 * Utility function to determine if a project is on track
 * Used consistently across project list and project details
 */
export interface ProjectTrackData {
  status: string;
  start_date?: string | null;
  delivered_date?: string | null;
  promised_delivery_date?: string | null;
}

export type TrackStatus = 'on_track' | 'off_track' | null;

export function getProjectTrackStatus(project: ProjectTrackData): TrackStatus {
  const today = new Date();
  const promisedDate = project.promised_delivery_date ? new Date(project.promised_delivery_date) : null;
  const deliveredDate = project.delivered_date ? new Date(project.delivered_date) : null;
  
  // If already delivered, check if delivered on time
  if (deliveredDate) {
    if (!promisedDate) return null;
    return deliveredDate <= promisedDate ? 'on_track' : 'off_track';
  }
  
  // If no promised date, can't determine track status
  if (!promisedDate) return null;
  
  // Simple logic: if today <= promised date → "On Track"
  return today <= promisedDate ? 'on_track' : 'off_track';
}